<template>
  <transition name="fade">
    <div class="spain-disclaimer" v-if="show && history[currentStep].field['game-type']!=='preloader'">
      * Antes de pinchar en "continuar" y enviarnos su solicitud de préstamo, debe entender que:
      <a @click="showModal" class="sigue-leyendo">Sigue leyendo</a>
    </div>
  </transition>
</template>

<script>
import ModalComponent from '../assetComponents/ModalComponent'
import {mapState} from 'vuex'

export default {
  name: 'EsDisclaimer',
  data () {
    return {
      show: false
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep
    })
  },
  mounted () {
    setTimeout(() => {
      this.show = true
    }, 1500)
  },
  methods: {
    showModal (e) {
      e.preventDefault()
      console.log('modal')
      this.$FModal.show(
        {
          component: ModalComponent
        },
        {
          content: `<ul>
                      <li>Se le creará automáticamente una cuenta de usuario. Sin estar en posesión de una cuenta no podrá hacer uso de nuestros servicios. Para más información por favor consulte nuestras <a href="/condiciones-generales/" target="_blank">Condiciones Generales</a>.</li>
                      <li>Sus datos personales se compartirán con todos o con alguno de los siguientes <a href="/socios/" target="_blank">prestamistas</a> con el fin de proporcionarle posibles ofertas de préstamos. Sin compartir sus datos personales con todos o alguno de los prestamistas de la lista (lo cual es necesario para hacerle ofertas de préstamos) no seremos capaces de prestarles nuestros servicios. Hemos llegado a acuerdos con todos los prestamistas en relación con el tratamiento de los datos de carácter personal de nuestros clientes, para cerciorarnos de que solo van a usar sus datos personales con los fines previstos (i.e. proporcionarles distintas ofertas de préstamos). Tenga en cuenta que los prestamistas actúan como responsables del tratamiento de datos personales independientes y que Fininity no puede ser responsable por sus actividades de tratamiento. Para más información sobre este punto, por favor, consulte nuestras <a href="/condiciones-generales/" target="_blank">Condiciones Generales</a> y <a href="/politica-privacidad/" target="_blank">Política de Privacidad</a>.</li>
                    </ul>`
        }
      )
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/hardcoreComponents/EsDisclaimer.vue